import { OPEN_NAVIGATION_MENU, CLOSE_NAVIGATION_MENU } from "OK/LayoutEventBuses";

export function activate(el: HTMLInputElement) {
    OPEN_NAVIGATION_MENU.on(() => {
        el.checked = true;
    }, null);

    CLOSE_NAVIGATION_MENU.on(() => {
        el.checked = false;
    }, null);
}
